// Predefined palette of distinguishable colors for collaborative cursors
const COLLAB_COLORS = [
  '#E57373', // red
  '#64B5F6', // blue
  '#81C784', // green
  '#FFB74D', // orange
  '#BA68C8', // purple
  '#4DD0E1', // cyan
  '#F06292', // pink
  '#AED581', // light green
  '#FFD54F', // amber
  '#7986CB', // indigo
];

/**
 * Generate a deterministic color for a user based on their ID.
 * Same user always gets the same color.
 */
export function generateUserColor(userId) {
  if (!userId) return COLLAB_COLORS[0];

  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = ((hash << 5) - hash) + userId.charCodeAt(i);
    hash = hash & hash; // Convert to 32-bit integer
  }
  return COLLAB_COLORS[Math.abs(hash) % COLLAB_COLORS.length];
}
